import React, { ReactNode, useEffect, useState, Children, cloneElement } from 'react'
import { Loader } from '@next-nx/shared-ui/atoms'
import {
  INITIAL_MAP_COORDS,
  INITIAL_MAP_ZOOM,
  GOOGLE_MAPS_API_KEY,
  GOOGLE_MAPS_LIBRARIES,
} from '@next-nx/utils/settings'
import { GoogleMap, useLoadScript, MarkerClusterer } from '@react-google-maps/api'

interface Props {
  showMarkers: boolean
  mapCoords: {
    lat: number
    lng: number
  }
  setSelectedItem: (v: any) => void
  zoom?: number
  items: any[]
  className?: string
  mapContainerClassName?: string
  loaderClassName?: string
  children?: ReactNode
}

const StorelocatorMap = (props: Props) => {
  const {
    mapCoords = INITIAL_MAP_COORDS,
    zoom = INITIAL_MAP_ZOOM,
    showMarkers = false,
    setSelectedItem = () => undefined,
    items = [],
    children = undefined,
    mapContainerClassName = '',
    loaderClassName = '',
  } = props

  const { isLoaded } = useLoadScript({
    id: 'google-map-script',
    googleMapsApiKey: GOOGLE_MAPS_API_KEY,
    libraries: GOOGLE_MAPS_LIBRARIES,
  })

  const [map, setMap] = useState<any>(null)

  const arrayChildren = Children.toArray(children)

  useEffect(() => {
    if (map && window?.google) {
      let bounds = new window.google.maps.LatLngBounds()

      if (showMarkers) {
        if (items.length) {
          items.forEach((item) => {
            bounds.extend(
              new window.google.maps.LatLng(Number(item.latitudine), Number(item.longitudine))
            )
          })

          bounds.extend(new window.google.maps.LatLng(mapCoords.lat, mapCoords.lng))

          map.fitBounds(bounds)
        } else {
          map.panTo(new window.google.maps.LatLng(mapCoords.lat, mapCoords.lng))
        }
      }
    }
  }, [isLoaded, map, items])

  return (
    <>
      {isLoaded ? (
        <GoogleMap
          mapContainerClassName={mapContainerClassName}
          zoom={zoom}
          center={mapCoords}
          onClick={() => setSelectedItem(null)}
          onLoad={(map) => {
            setMap(map)
          }}
          onUnmount={(map) => {
            setMap(map)
          }}
        >
          <MarkerClusterer averageCenter enableRetinaIcons gridSize={90} maxZoom={10}>
            {(clusterer) =>
              Children.map(arrayChildren, (child) => {
                return cloneElement(child, {
                  clusterer,
                })
              })
            }
          </MarkerClusterer>
        </GoogleMap>
      ) : (
        <Loader className={loaderClassName} />
      )}
    </>
  )
}

export default StorelocatorMap
